import { FileSpreadsheet, Upload } from "@cakewalk/ui/icons";
import { V2Button, V2Typography } from "@cakewalk/ui/v2";

/**
 * "{fileName} · N records found" summary with an upload-another action.
 *
 * Lifted from the platforms-demo payroll-sync module — the company-census team
 * step is the only consumer, so this trimmed copy carries just that one piece
 * (the demo file also held the payroll-import roster cards, which this flow
 * does not use).
 */
export function FileImportSummary({
  fileName,
  recordCount,
  onUploadAnother,
}: {
  fileName: string;
  recordCount: number;
  onUploadAnother: () => void;
}) {
  return (
    <section className="cw-blur-in-up flex flex-wrap items-center justify-between gap-3 rounded-[12px] border border-cw-v2-border/70 bg-transparent px-4 py-3">
      <div className="flex min-w-0 items-center gap-3">
        <span className="bd-v2-pop-in flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cw-v2-accent text-white">
          <FileSpreadsheet className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <V2Typography variant="body" className="truncate font-semibold">
            {fileName}
          </V2Typography>
          <V2Typography variant="meta" muted>
            {recordCount} {recordCount === 1 ? "record" : "records"} found · edit any profile below
          </V2Typography>
        </div>
      </div>
      <V2Button
        variant="link"
        size="sm"
        iconPrefix={<Upload className="h-4 w-4" />}
        onClick={onUploadAnother}
        data-track="button-roster-upload-another"
      >
        Upload another
      </V2Button>
    </section>
  );
}
